import { useContext } from "react";
import { AuthContext } from "@/contexts/auth-context";

/**
 * Custom hook to access Auth context
 * Must be used within an AuthProvider
 */
export function useAuth(): any {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
